/**
 * Interop between "export default" and "module.exports".
 */
export function interopDefault(mod: any) {
  return mod.default || mod
}
